import { render } from "./ChatBox.vue?vue&type=template&id=4ea1cccf"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__